<script lang="ts">
    import {getMasonryGridContext} from 'shared/layouts';
    import {tick} from 'svelte';

    export let animate = true;

    let elementHeight: number;
    let elementWidth: number;

    const context = getMasonryGridContext();
    $: if (elementHeight > 0 || elementWidth > 0) tick().then(() => context.updateGrid());
</script>

<div class="kp-masonry-grid-item"
     class:item-hover-animation={animate}
     style:height="{elementHeight}px"
     style:--row-gap={context.rowGap}>

    <div class="inner-container" bind:clientHeight={elementHeight} bind:clientWidth={elementWidth}>
        <slot/>
    </div>
</div>

<style lang="less">
    .kp-masonry-grid-item {
        &.item-hover-animation {
            transition: opacity 0.3s ease-in-out;

            &:hover {
                opacity: 0.5;
            }
        }

        .inner-container {
            padding-bottom: calc(var(--row-gap) - 1px);
        }
    }
</style>